import React from 'react';
import PropTypes from 'prop-types';
import HamBurgerMenuIcon from '@material-ui/icons/Menu';
import layoutRoutes from 'components/core/AppRoutes/layoutRoutes';
import BreadCrumbs from './BreadCrumbs';

import * as Styled from './TopBar.styled';

const TopBar = (props) => {
  const { isSideBarOpen, handleSideBarOpen } = props;

  return (
    <>
      <Styled.TopBarStaticContainer>
        <Styled.TopBarFixedContainer sidebar={isSideBarOpen ? 'true' : ''}>
          <Styled.DrawerMenuOpenButton
            variant={'none'}
            aria-label="Open drawer"
            sidebar={isSideBarOpen ? 'true' : ''}
            onClick={handleSideBarOpen}
          >
            <HamBurgerMenuIcon />
          </Styled.DrawerMenuOpenButton>
          <BreadCrumbs routesList={layoutRoutes} />
          <Styled.FlexGrower />
        </Styled.TopBarFixedContainer>
      </Styled.TopBarStaticContainer>
    </>
  );
};

TopBar.propTypes = {
  isSideBarOpen: PropTypes.bool.isRequired,
  handleSideBarOpen: PropTypes.func.isRequired,
};

export default TopBar;
